<template>
  <div id="Cardsales">
    <ConfirmInfoDialog
      :merchant="checked"
      @close="isDialogOpen = false"
      @success="store"
      v-if="isDialogOpen"
    />
    <div class="list">
      <div class="list--title">
        <h3><strong>비상금 신청</strong>을 진행할<br><strong>사업장을 선택</strong>해주세요.</h3>
      </div>
      <Selection
        v-for="(merchant, index) in merchantGroups"
        :key="index"
        :merchant="merchant"
        :checked="checked"
      />
      <v-sheet
        v-if="isLoading"
      >
        <v-skeleton-loader
          class="mx-auto"
          type="image"
          max-height="78"
        ></v-skeleton-loader>
  </v-sheet>
    </div>
    <FooterButton :title="'완료'" :active="checked.regBuzNo" @click="isDialogOpen = true"/>
  </div>
</template>

<script>
import FooterButton from '@/components/footer/button'
import ConfirmInfoDialog from '@/components/modal/ConfirmInfoDialog'
import Selection from './components/Selection'

import AuthService from '@/service/auth/AuthService'

import cardsalesApi from '@/api/now/cardsalesApi'
import StatusService from '@/service/status/StatusService'

export default {
  name: 'List.vue',
  components: {
    ConfirmInfoDialog,
    Selection,
    FooterButton
  },
  data: function () {
    return {
      checked: {
        merGrpNm: '',
        regBuzNo: ''
      },
      provider: 'cfa',
      isDialogOpen: false,
      isLoading: false,
      merchantGroups: []
    }
  },
  async created() {
    this.$store.commit('ui/headerTitle', '카드 매출 연동')
    await StatusService.syncStatus()
    await this.getmerchantGroups()
  },
  methods: {
    async getmerchantGroups() {
      try {
        this.isLoading = true
        let { data } = await cardsalesApi.getmerchantGroups(this.provider)
        this.merchantGroups = data
      } catch (e) {
        console.log('getmerchantGroups', e)
      } finally {
        this.isLoading = false
      }
    },
    async store() {
      try {
        await cardsalesApi.setMerchantInfos(this.provider, this.checked)
        await AuthService.syncProfile()
        this.$router.push({ name: 'dashboard' })
      } catch (e) {
        if (e && e.status && e.status === 400) {
          alert('이미 등록된 사업자번호입니다. 고객센터 02-6925-1788로 문의주세요.')
        } else {
          alert('문제가 발생했습니다. 문제가 지속될 시 고객센터 02-6925-1788로 문의주세요.')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  width: 100%;
  padding-left: 6.67vw;
  padding-right: 6.67vw;
  &--title {
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;
    line-height: 1.56;
  }
}
</style>
